class LazyLoad {
  constructor() {
    this.lazyBackgrounds = Array.prototype.slice.call( document.querySelectorAll(".lazy-background"));
    this.lazyImages = Array.prototype.slice.call( document.querySelectorAll(".lazy"));
    this.events();
  }

  events() {
    if( this.lazyBackgrounds ) {
      document.addEventListener( "DOMContentLoaded", this.lazyloadBackgrounds.bind(this) );
    }

    if( this.lazyImages ) {
      document.addEventListener( "DOMContentLoaded", this.lazyloadImages.bind(this) );
    }

  }

  // methods

  lazyloadBackgrounds() {
    if("IntersectionObserver" in window ) {
      let lazyBackgroundObserver = new IntersectionObserver( function( entries, observer ) {
        entries.forEach( function( entry ) {
          if( entry.isIntersecting ) {
            // background images
            entry.target.classList.add("visible");
            lazyBackgroundObserver.unobserve(entry.target);
          }
        });
      });

      this.lazyBackgrounds.forEach( function( lazyBackground ) {
        lazyBackgroundObserver.observe(lazyBackground);
      });

    }
  }

  lazyloadImages() {
    if("IntersectionObserver" in window ) {
      let lazyImageObserver = new IntersectionObserver( function( entries, observer ) {
        entries.forEach( function( entry ) {
          if( entry.isIntersecting ) {
            // image elements
            let lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.classList.remove("lazy");
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      });

      this.lazyImages.forEach( function( lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });

    }
  }

}

export default LazyLoad;